import { API_URL } from '../../../../constants/urls.constants';
import type { CommonResponse } from '../../../../types/global.types';
import { appServiceApi } from '../../../apis/app-service.api';
import { APP_API_TAGS } from '../../../app.constants';
import type {
  AuditLogsParams,
  AuditLogsResponse,
  ControlPanelStatsResponse,
  GetControlPanelStatesParams,
} from './dashboard.type';

const { CTRL_PANEL_STATES, AUDIT_LOGS } = APP_API_TAGS || {};

export const dashboardApi = appServiceApi.injectEndpoints({
  endpoints: (builder) => ({
    // ------ Start: API Endpoints for Dashboard ------
    getControlPanelStates: builder.query<
      CommonResponse<{
        data: ControlPanelStatsResponse;
      }>,
      GetControlPanelStatesParams
    >({
      query: ({ organization_id }) => ({
        url: `${API_URL.dashboard}/control-panel-stats?organization_id=${organization_id}`,
        method: 'GET',
      }),
      providesTags: [CTRL_PANEL_STATES],
    }),

    getAuditLogs: builder.query<
      CommonResponse<AuditLogsResponse>,
      AuditLogsParams
    >({
      query: (params) => ({
        url: '/audit-logs',
        method: 'GET',
        params,
      }),
      providesTags: [AUDIT_LOGS],
    }),
    // ------ End: API Endpoints for Dashboard ------
  }),
});

export const { useGetControlPanelStatesQuery, useGetAuditLogsQuery } =
  dashboardApi;
